import { Pagination } from 'src/models/pagination.model';

export const commissionDefaultParams = {
  postPerPage: 10,
  currentPage: 1,
  sortBy: 'id',
  sortDirection: 'ASC',
};

export const rolesDefaultParams: Pagination = {
  postPerPage: 10,
  currentPage: 1,
  sortBy: 'id',
  sortDirection: 'ASC',
};

export const userDefaultParams: Pagination = {
  postPerPage: 10,
  currentPage: 1,
  sortBy: 'id',
  sortDirection: 'ASC',
};

export const getParamsFromUrl = (defaultParams, location) => {
  if (!location?.search) {
    return defaultParams;
  }

  const searchParams = new URLSearchParams(location.search);

  const paramsObj = {};
  Object.entries(defaultParams).forEach(([key, val]) => {
    const value = searchParams.get(key);

    if (value) {
      const isNumber = typeof defaultParams[key] === 'number';
      const isBoolean = value === 'true' || value === 'false';
      const isArray = value?.includes(',');

      if (isArray) {
        paramsObj[key] = value.split(',');
      } else if (isBoolean) {
        paramsObj[key] = value === 'true';
      } else if (isNumber) {
        paramsObj[key] = +value;
      } else {
        paramsObj[key] = value;
      }
    } else {
      paramsObj[key] = val;
    }
  });

  return paramsObj;
};

export const setParamsToUrl = (params, navigate) => {
  let urlParams = '';

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === 0) {
      urlParams += `${urlParams === '' ? '?' : '&'}${key}=${value}`;
    }
  });

  if (window.location.search !== urlParams) {
    navigate(`${window.location.pathname}${urlParams}`, { replace: true });
  }
};
